import { Component } from '@angular/core';
import { AlertController, NavController, NavParams} from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ModalController } from "ionic-angular";
import { ReportCustomerClientPage } from "../report-customer-client/report-customer-client";
import { ReportSearchLocationPage } from "../report-search-location/report-search-location";

@Component({
  selector: 'page-report-location',
  templateUrl: 'report-location.html',
})
export class ReportLocationPage {

  data: any;
  requiresAction = 0;
  allowLocationSearch = true;
  reportForm: FormGroup;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController
  ) {
    this.reportForm = this.formBuilder.group({
      street: [''],
      number: [''],
      letter: [''],
      zipcode: ['', Validators.compose([Validators.required])],
      city: [''],
      country: ['NL']
    });

    this.data = {};
    // Load selected workorder into data
    if(this.navParams.get('data')){
      this.data = this.navParams.get('data');
      if(this.data._selected_workorder){
        this.data.workorder_id = this.data._selected_workorder.workorder_id;
        this.allowLocationSearch = false;
        if(this.data._selected_workorder.location){
          this.reportForm.patchValue(this.data._selected_workorder.location);
          this.data.location = this.data._selected_workorder.location;
          this.data._selected_location = this.data._selected_workorder.location;
        }
        if(this.data._selected_workorder.customers){
          this.data._selected_customers = this.data._selected_workorder.customers;
        }
      }
    }
  }

  public searchAddress(){
    this.modalCtrl.create(ReportSearchLocationPage, {
      form: this.reportForm,
      data: this.data
    }).present();
  }

  public save(){
    if(this.reportForm.valid) {
      if(this.data._selected_location && !this.reportForm.pristine) {
        this.alertCtrl.create({
          message: 'U heeft de gegevens van de geselecteerde locatie gewijzigd. Wilt u deze gegevens ook aanpassen bij de reeds geregistreerde locatie?',
          buttons: [
            {
              text: 'Ja',
              handler: () => {
                this.requiresAction = 1;
                this.saveAndContinue();
              }
            }, {
              text: 'Nee',
              handler: () => {
                this.requiresAction = 2;
                this.saveAndContinue();
              }
            }
          ]
        }).present();
      } else {
        this.saveAndContinue();
      }
    }
  }

  private saveAndContinue(){
    if(this.data._selected_location){
      this.data.location = this.data._selected_location;
      if(!this.reportForm.pristine){
        Object.assign(this.data.location, this.reportForm.value);
        this.data.location._requires_action = this.requiresAction;
      }
    } else {
      let location = this.data.location ? this.data.location : {};
      Object.assign(location, this.reportForm.value);
      this.data.location = location;
    }
    if(this.data._selected_customers){
      if(this.data._selected_customers.invoice){
        this.data._selected_customers.client._has_invoice_customer = true;
      }
      if(this.data._selected_customers.external){
        this.data._selected_customers.client._has_external_customer = true;
      }
      this.data.customers = this.data._selected_customers;
    }
    console.log(this.data);
    this.navCtrl.push(ReportCustomerClientPage, { data: this.data });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportLocationPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-location/report-location.ts